import React from 'react';
import { LinkStyled, Space } from '@gr-monorepo/common/ui';
import { landingSafeTerritoryUrl, safeInternet } from './constants';

export const getTextMessageTwoModal = (utm: string) => {
  return `Здравствуйте! На платформе Учи.ру проходит соревнование «Территория безопасности» для педагогов и учеников 1–9 классов. Подробная информация: ${landingSafeTerritoryUrl + utm} \n \nДо 28 декабря включительно можно присоединиться к четвертому этапу. Он посвящен развитию цифровых компетенций и навыков безопасного поведения в интернете. Учителям необходимо: \n \n1. С помощью сервиса «Мои задания» выдать ученикам интерактивные карточки или тестовые упражнения. \n2. Организовать прохождение школьниками олимпиады «Безопасный интернет»: ${safeInternet + utm} \n3. Убедиться, что минимум 15 учащихся или весь класс, если их меньше, выполнили задания. \n \nВ декабре это последняя возможность для учителей получить награды «Территории безопасности».`;
};
export const ContentTwoModal = ({ utm }: { utm: string }) => {
  return (
    <div style={{ fontSize: '16px', lineHeight: '22.4px' }}>
    <p>
      Просим передать педагогам информацию и сообщить, что соревнование скоро закончится — нужно успеть принять в нем участие.
    </p>
    <Space size={24} axis="vertical" />
    <div style={{ background: 'rgba(9, 21, 38, 0.07)', padding: '24px' }}>
      <p>
        Здравствуйте! На платформе Учи.ру проходит соревнование «Территория безопасности» для педагогов и учеников 1–9 классов. Подробная информация:
        <LinkStyled style={{ color: '#7F39FB' }} href={landingSafeTerritoryUrl + utm} target="_blank">
          {' '}
          https://distant.uchi.ru/safeterritory
        </LinkStyled>
      </p>
      <Space size={24} axis="vertical" />
      <p>
        <div>До 28 декабря включительно можно присоединиться к четвертому этапу. Он посвящен развитию цифровых компетенций и навыков безопасного поведения в интернете. Учителям необходимо:</div>
        <Space size={24} axis="vertical" />
        <div>
          1. С помощью сервиса «Мои задания» выдать ученикам интерактивные карточки или тестовые упражнения.
        </div>
        <div>
          2. Организовать прохождение школьниками олимпиады «Безопасный интернет»: {' '}
          <LinkStyled style={{ color: '#7F39FB' }} href={safeInternet + utm} target="_blank">
            {' '}
            https://safenet.uchi.ru
          </LinkStyled>
        </div>
        <div>
          3. Убедиться, что минимум 15 учащихся или весь класс, если их меньше, выполнили задания.
        </div>
      </p>
      <Space size={24} axis="vertical" />
      <p>В декабре это последняя возможность для учителей получить награды «Территории безопасности».</p>
    </div>
  </div>
  );
};
